import React from 'react';

const colorConfig = {
  blue: { accent: 'var(--color-info)', bg: 'rgba(37, 99, 235, 0.08)' },
  green: { accent: 'var(--color-success)', bg: 'rgba(22, 163, 74, 0.08)' },
  red: { accent: 'var(--color-error)', bg: 'rgba(220, 38, 38, 0.08)' },
  orange: { accent: 'var(--color-warning)', bg: 'rgba(217, 119, 6, 0.08)' },
  purple: { accent: 'var(--color-ai)', bg: 'rgba(124, 58, 237, 0.08)' },
};

export function SummaryCard({ title, value, change, color = 'blue' }) {
  const cfg = colorConfig[color] || colorConfig.blue;
  const isPositive = change > 0;
  const isNegative = change < 0;

  return (
    <div style={{
      background: 'var(--bg-primary)',
      border: '1px solid var(--border-color)',
      borderRadius: 12,
      padding: '20px 22px',
      position: 'relative',
      overflow: 'hidden',
    }}>
      {/* Accent bar */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0,
        height: 3, background: cfg.accent,
      }} />

      <p style={{
        fontSize: 12, fontWeight: 600, color: 'var(--text-muted)',
        textTransform: 'uppercase', letterSpacing: '0.5px',
        marginBottom: 8,
      }}>
        {title}
      </p>

      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between' }}>
        <p style={{
          fontSize: 28, fontWeight: 800, color: 'var(--text-primary)',
          lineHeight: 1, fontVariantNumeric: 'tabular-nums',
          margin: 0,
        }}>
          {typeof value === 'number' ? value.toLocaleString() : value}
        </p>

        {change !== null && change !== undefined && (
          <div style={{
            display: 'flex', alignItems: 'center', gap: 3,
            fontSize: 13, fontWeight: 700,
            color: isPositive ? 'var(--color-success)' : isNegative ? 'var(--color-error)' : 'var(--text-muted)',
          }}>
            {isPositive && (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 15l-6-6-6 6" />
              </svg>
            )}
            {isNegative && (
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M6 9l6 6 6-6" />
              </svg>
            )}
            {isPositive ? '+' : ''}{change}%
          </div>
        )}
      </div>
    </div>
  );
}

export default SummaryCard;
